import { GenericObject } from "utility/misc";

export default function redirectToTeamsWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/teams_webhook/connect");
}
